import { CircularProgress, Stack, Typography } from '@mui/material';
import { LogoMangoIcon } from '~/shared/icons/LogoMangoIcon';

export const HomePage = () => {
  return (
    <div>
      <Stack
        display="flex"
        flexDirection="column"
        alignItems="center"
        padding={25}
        gap={8}>
        <Stack display="flex" flexDirection="row" gap={1} alignItems="center">
          <LogoMangoIcon />
          <Typography component="h1" fontSize="64px" fontWeight={700}>
            Mango CPA
          </Typography>
        </Stack>
        <CircularProgress size={100} sx={{ color: '#FDB602' }} />
        <Typography component="h6" fontWeight={600}>
          v1.0.1
        </Typography>
      </Stack>
    </div>
  );
};
